import { AnyAction } from 'redux';

import { Brands, getBrands } from '@ttstr/api';
import { ThunkActionCreator } from '.';

export const BRANDS_REQUESTED = 'BRANDS.BRANDS_REQUESTED';
export const BRANDS_RECEIVED = 'BRANDS.BRANDS_RECEIVED';
export const BRANDS_FAILED = 'BRANDS.BRANDS_FAILED';

export interface BrandsReceivedAction extends AnyAction {
  payload: {
    brands: Brands;
  };
}

let requestBrandsAbortController: AbortController;
export const requestBrands: ThunkActionCreator = () => async (dispatch) => {
  if (requestBrandsAbortController) requestBrandsAbortController.abort();

  requestBrandsAbortController = new AbortController();
  dispatch({
    type: BRANDS_REQUESTED,
  });

  try {
    const brands = await getBrands({ signal: requestBrandsAbortController.signal });
    dispatch<BrandsReceivedAction>({
      type: BRANDS_RECEIVED,
      payload: {
        brands,
      },
    });
  } catch (error) {
    dispatch({
      type: BRANDS_FAILED,
      payload: {
        error,
      },
    });
  }
};
